import "./CoursePaymentForm.css";
import {TextInput} from "@mantine/core";
import {createRef} from "react";
import PhoneInputField from "../../../components/PhoneInputField/PhoneInputField";

const CoursePaymentForm = ({form, isRegistered, setIsRegistered, paymentFormTexts}) => {
    const {title, fields, oldMemberMessage, newMemberMessage} = paymentFormTexts;
    const {name, lastname, email, emailConfirmation, phone, disclaimers} = fields;
    const ref = createRef()

    return (
        <div className="coursePaymentForm-father-div">
            <div className="coursePaymentForm-father-container">
                <h3 className="coursePaymentForm-description-text">
                    {title}
                </h3>
                <p className="coursePaymentForm-already-have-account" onClick={() => {setIsRegistered(!isRegistered)}}>
                    {isRegistered ? newMemberMessage : oldMemberMessage }
                </p>
                <div className="coursePaymentForm-form-div">
                    <form className="coursePaymentForm-form-styling" onSubmit={form.onSubmit(console.log)}>
                        {!isRegistered &&
                        <TextInput
                            classNames={{
                                root: "coursePaymentForm-first-textInput",
                                label: "coursePaymentForm-textInput-labels",
                                wrapper: "coursePaymentForm-textInput-wrapper",
                                error: "coursePaymentForm-textInput-error",
                            }}
                            label={name.label}
                            placeholder={name.placeholder}
                            {...form.getInputProps("name")}
                            onBlur={(event) =>
                                form.setFieldValue("name", event.currentTarget.value)
                            }
                        />
                        }
                        {!isRegistered &&
                        <TextInput
                            classNames={{
                                root: "coursePaymentForm-second-textInput",
                                label: "coursePaymentForm-textInput-labels",
                                wrapper: "coursePaymentForm-textInput-wrapper",
                                error: "coursePaymentForm-textInput-error",
                            }}
                            label={lastname.label}
                            placeholder={lastname.placeholder}
                            {...form.getInputProps("apellido")}
                            onBlur={(event) =>
                                form.setFieldValue("apellido", event.currentTarget.value)
                            }
                        />
                        }
                        <TextInput
                            classNames={{
                                root: "coursePaymentForm-third-textInput",
                                label: "coursePaymentForm-textInput-labels",
                                wrapper: "coursePaymentForm-textInput-wrapper",
                                error: "coursePaymentForm-textInput-error",
                            }}
                            mt="sm"
                            label={email.label}
                            placeholder={email.placeholder}
                            {...form.getInputProps("email")}
                            onBlur={(event) =>
                                form.setFieldValue("email", event.currentTarget.value)
                            }
                        />
                        <TextInput
                            classNames={{
                                root: "coursePaymentForm-third-textInput",
                                label: "coursePaymentForm-textInput-labels",
                                wrapper: "coursePaymentForm-textInput-wrapper",
                                error: "coursePaymentForm-textInput-error",
                            }}
                            mt="sm"
                            label={emailConfirmation.label}
                            placeholder={emailConfirmation.placeholder}
                            {...form.getInputProps("emailConfirmation")}
                            onBlur={(event) =>
                                form.setFieldValue("emailConfirmation", event.currentTarget.value)
                            }
                        />
                        {!isRegistered &&
                        <PhoneInputField
                            ref={ref}
                            phone={phone.label}
                            name="telefono"
                            fieldError={form.errors.telefono}
                            {...form.getInputProps("telefono")}
                            onChange={(value) => {
                                form.setFieldValue("telefono", value)
                            }}
                        />
                        }
                    </form>
                </div>
                <p className="coursePaymentForm-note">{disclaimers.first}</p>
                <p className="coursePaymentForm-note">{disclaimers.second}</p>
            </div>
        </div>
    );
};

export default CoursePaymentForm;
